import React from 'react'
import { Collapse } from 'react-bootstrap'
import { injectIntl } from 'react-intl'

import messages from './messages'

import MiniMap from 'modules/Content/MiniMap'

import DateTools from 'utils/dates/dateTools'
import APPURL from 'utils/app/urls'

class ReportTableSubheader extends React.Component { 

  constructor(props) {
    super( props );

    const {
      intl: { formatMessage }
    } = props;

    this.formatMessage = formatMessage;

    this.state = {
      collapsed: true
    };
  }
    
  toggleCollapse() {
    this.setState({
	    collapsed: !this.state.collapsed
    });
	}

  render() {
    const dimensionLinks = {
      0: "#anchor-dimension-0",
      1: "#anchor-dimension-1",
      2: "#anchor-dimension-2",
      3: "#anchor-dimension-3"
    };

    const lastUpdated = DateTools.formatDateForContentHeader(this.props.lastUpdated);
    let collpaseIconClass = "fal " + (this.state.collapsed ? "fa-angle-down" : "fa-angle-up");
		const methodologyLink = APPURL.getMethodologyLink(this.props.history.location.pathname);

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-md-12">
            <h1>
              {this.formatMessage(messages.ReportTable_title) }
              <p className='last-updated' dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.ReportTable_lastUpdated, { lastUpdated }) }}></p>
            </h1>
            <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.ReportTable_p1, { methodologyLink } ) }}></p>
            <MiniMap dimensionLinks={dimensionLinks}/>
            <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.ReportTable_p2) }}></p>
            <div className='small ork-collapsible report-table'>
              <h4 onClick={this.toggleCollapse.bind(this)}>{this.formatMessage(messages.ReportTable_instructions_title)} <i className={collpaseIconClass}></i></h4>
              <Collapse in={!this.state.collapsed}>
                <div dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.ReportTable_instructions_paragraph) }}></div>
              </Collapse>
            </div>  
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl( ReportTableSubheader );



// WEBPACK FOOTER //
// ./src/components/ReportTableSubheader/ReportTableSubheader.js